// keeping separate because rest of the files have other imports in utils
export const getHttpApiUrl = () => {
	if (process?.client) {
		const config = useRuntimeConfig();
		return config.public.httpApiBaseUrl as string;
	}
	return process.env.NUXT_PUBLIC_HTTP_API_BASE_URL as string;
};
